import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { faSignOut, faUser, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../../images/Docusync-logo.png';

const Navbar = ({ setLoad, logoutF, setIsImageUploaded, isNewVendor, setIsNewVendor }) => {
  const [activeButton, setActiveButton] = useState('dashboard');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const changeLoadSuppliers = () => {
    setActiveButton('suppliers');
  };

  const changeLoad = () => {
    setActiveButton('dashboard');
    setIsNewVendor(true);
    setIsImageUploaded({ isImage: false, isOcr: false });
    setLoad(false);
    setIsMenuOpen(false);
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <nav className='main-nav'>
      <div className='nav-container d-flex justify-content-between align-items-center'>
        <div className='navleft'>
          <Link to="/" className="logo-link" onClick={() => setIsMenuOpen(false)}>
            <div className="logo">
              <img src={logo} alt="DocuSync Logo" className='logo-img' />
            </div>
          </Link>
        </div>

        <div className={`nav-menu ${isMenuOpen ? 'is-open' : ''}`}>
          <div className="nav-links">
            <Link to="/" onClick={changeLoad}>
              <button className={activeButton === 'dashboard' ? 'btn-active' : 'btn-normal'}>Dashboard</button>
            </Link>
            <Link to="/uploadedDocs" onClick={() => { changeLoadSuppliers(); setIsMenuOpen(false); }}>
              <button className={activeButton === 'suppliers' ? 'btn-active' : 'btn-normal'}>Suppliers</button>
            </Link>
          </div>
          <div className="nav-right">
            <Link to="/my-account" onClick={() => setIsMenuOpen(false)}>
              <button className='btn-bg-n'>Account <FontAwesomeIcon icon={faUser} /></button>
            </Link>
            <button onClick={() => { logoutF(); setIsMenuOpen(false); }} className='btn-bg-n'>LogOut <FontAwesomeIcon icon={faSignOut} /></button>
          </div>
        </div>

        <button className="nav-toggle" onClick={toggleMenu} aria-label="Toggle navigation">
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
        </button>
      </div>
    </nav>
  )
}

export default Navbar